import React, { useState } from "react";
import AppButton from "../layout/AppButton";

const ToolRoleRegistrationsForm = ({ onCreateRole, loading = false }) => {
  const [roleName, setRoleName] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedRole = roleName.trim();
    if (!trimmedRole) {
      return;
    }

    await onCreateRole(trimmedRole);
    setRoleName("");
  };

  return (
    <div className="rr-wrap pb-4">
      <div className="rr-card">
        <div className="rr-cardHeader">
          <p className="rr-kicker">Tool Role Intake</p>
          <h5 className="rr-title">Tool Role Registration</h5>
          <p className="rr-subtitle">Create a new tool role, then assign it the pages it can access.</p>
        </div>

        <div className="rr-content">
          <div className="rr-sidePanel">
            <div className="rr-sideBadge">Info</div>
            <ul className="rr-checklist">
              <li>Use a clear and unique tool role name.</li>
              <li>After creating the role, use "Assign Pages" to pick which pages it can access.</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row g-3 rr-formGrid">
              <div className="col-12">
                <label htmlFor="toolRoleName" className="form-label rr-label">
                  Tool Role Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="toolRoleName"
                  name="toolRoleName"
                  type="text"
                  className="form-control rr-input"
                  placeholder="Enter tool role name"
                  value={roleName}
                  onChange={(event) => setRoleName(event.target.value)}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="d-flex gap-2 mt-4 rr-actions justify-content-end">
              <AppButton type="reset" variant="secondary" onClick={() => setRoleName("")} disabled={loading}>Clear</AppButton>
              <AppButton type="submit" variant="fill" disabled={!roleName.trim() || loading}>{loading ? "Creating..." : "Create Tool Role"}</AppButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ToolRoleRegistrationsForm;
